import React from 'react'



export default class PretnTotal extends React.Component {

  render() {


    let total = 0.00, totalPrice=0.00, totalTax=0.00, totalDiscount=0.00

    if(typeof this.props.pretn !=="undefined") {

      let pretn = this.props.pretn
      totalPrice = pretn.totalPrice
      totalDiscount = pretn.totalDiscount
      totalTax = pretn.totalTax
      total = pretn.total
    }



    return (<section className="medium">
      <div className="row">
              <div className="col-xs-6 col-xs-offset-6 col-sm-3 col-sm-offset-9">

                <table className="table">
                  <tbody>
                  <tr><td>Amount</td><td>&nbsp;{totalPrice}</td></tr>
                  <tr><td>Discount</td><td>-{totalDiscount}</td></tr>
                  <tr><td>GST</td><td>&nbsp;{totalTax}</td></tr>
                  <tr><td>Total</td><td>&nbsp;{total}</td></tr>
                  </tbody>
                </table>

              </div>
      </div>
      </section>)
  }
}



// WEBPACK FOOTER //
// ./src/components/debit/rowelements/pretntotal.js